import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Form, Input } from 'antd';

import { AuthTitle } from '../../components';
import { useForgotPasswordMutation } from '../../store/api/auth';
import { register } from '../../store/slices/auth';
import styles from '../../styles/auth.module.scss';
import { Icon as CroplerIcon, Button } from '@cropler/ui-kit';
import { AuthPathNamesMap } from '../../constants/ui';
import { ApiFieldError } from '../../types';

const VerifyEmail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const [forgotPassword, { isSuccess, isError, error }] = useForgotPasswordMutation();

  useEffect(() => {
    if (isSuccess) {
      // navigate('/login/reset');
      navigate('/reset-password');
    }
  }, [isSuccess, navigate]);

  const onSubmit = () => {
    form
      .validateFields()
      .then(() => {
        const username = form.getFieldValue('username');
        dispatch(register({ username }));
        forgotPassword({ username });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (isError && error) {
      const username = form.getFieldValue('username');
      const [{ code, detail, attr }] = error as ApiFieldError[];

      const errorMessage = detail ? (
        code === 'invalid' && attr === 'username' ? (
          <>
            {detail}{' '}
            <Button type="link" onClick={() => navigate(`/${AuthPathNamesMap.signup}`)} size="small">
              {t('actions.signup')}
            </Button>
          </>
        ) : (
          detail
        )
      ) : (
        t('common.smthWrong')
      );

      form.setFields([{ name: 'username', value: username, errors: [errorMessage] as unknown as string[] }]);
    }
  }, [isError, error, form, t, navigate]);

  return (
    <>
      <div className={styles.formContainer}>
        <div className={styles.form}>
          <AuthTitle title={t('login.titleVerify')} withBackButton />
          <p className={styles.description} dangerouslySetInnerHTML={{ __html: t('login.textVarify') }}></p>
          <Form
            form={form}
            initialValues={{ username: '' }}
            autoComplete="off"
            requiredMark={false}
            className={styles.formPassword}
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: t('forms.validation.emailInvalid'),
                },
              ]}
            >
              <Input prefix={<CroplerIcon name="email" />} placeholder="Email" type="email" size={'large'} />
            </Form.Item>
          </Form>
          <Button type="primary" size={'large'} className={styles.buttonSubmit} onClick={onSubmit}>
            {t('login.buttonSendResetLink')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default VerifyEmail;
